module.exports = __webpack_public_path__ + "static/media/6.aece3b42.png";